import { NavLink, useLocation } from 'react-router-dom';
import { NAV_GROUPS, filterNavGroups, isNavActive } from './nav';
import { useAuthStore } from '../store/auth';

export function Sidebar() {
  const role = useAuthStore((s) => s.admin?.role);
  const pathname = useLocation().pathname;
  const groups = filterNavGroups(NAV_GROUPS, role);
  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <div className="sidebar__brand-mark">
          <img src="/logo.png" alt="Owlsome AI" />
        </div>
        <div>
          <div className="sidebar__brand-name">Owlsome AI</div>
          <div className="sidebar__brand-sub">运营管理平台</div>
        </div>
      </div>
      <nav className="sidebar__nav">
        {groups.map((group) => (
          <section key={group.key} className="sidebar__group">
            <div className="sidebar__group-title">{group.label}</div>
            {group.items.map((n) => (
              <NavLink
                key={n.key}
                to={n.to}
                className={() => 'sidebar__item' + (isNavActive(n.to, pathname) ? ' is-active' : '')}
              >
                <span style={{ display: 'inline-flex', width: 18 }}>{n.icon}</span>
                <span>{n.label}</span>
              </NavLink>
            ))}
          </section>
        ))}
      </nav>
    </aside>
  );
}
